import { useEffect } from 'react';

import { datadogRum } from '@datadog/browser-rum';
import { getAppConfig } from 'app/getConfig';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import { DefaultPrivacyLevel } from '@datadog/browser-core';
import { FeatureFlagEnum } from 'shared/constants/featureFlagEnum';

export const useInitializeRUM = () => {
  const isRUMEnabled = useFeatureIsOn(FeatureFlagEnum.dataDogRUM);
  const {
    NODE_ENV,
    DATADOG_REPORT_UI_CLIENT_TOKEN,
    DATADOG_REPORT_UI_RUM_APPLICATION_ID,
    DATADOG_REPORT_UI_RUM_DEFAULT_PRIVACY_LEVEL,
    DATADOG_REPORT_UI_RUM_SESSION_REPLAY_SAMPLE_RATE,
    DATADOG_REPORT_UI_RUM_SESSION_SAMPLE_RATE,
    AUTH_API_CLIENT_URL,
    REPORT_API_CLIENT_URL,
    AI_AVATAR_API_CLIENT_URL,
    AI_SUMMARY_API_CLIENT_URL,
  } = getAppConfig();

  const isAllowedToInit =
    isRUMEnabled && DATADOG_REPORT_UI_RUM_APPLICATION_ID && DATADOG_REPORT_UI_CLIENT_TOKEN;

  useEffect(() => {
    if (isAllowedToInit) {
      datadogRum.init({
        applicationId: DATADOG_REPORT_UI_RUM_APPLICATION_ID,
        clientToken: DATADOG_REPORT_UI_CLIENT_TOKEN,
        site: 'datadoghq.eu',
        service: 'report-ui',
        env: NODE_ENV,
        defaultPrivacyLevel: DATADOG_REPORT_UI_RUM_DEFAULT_PRIVACY_LEVEL as DefaultPrivacyLevel,
        sessionReplaySampleRate: parseInt(DATADOG_REPORT_UI_RUM_SESSION_REPLAY_SAMPLE_RATE),
        sessionSampleRate: parseInt(DATADOG_REPORT_UI_RUM_SESSION_SAMPLE_RATE),
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        allowedTracingUrls: [
          AUTH_API_CLIENT_URL,
          REPORT_API_CLIENT_URL,
          AI_AVATAR_API_CLIENT_URL,
          AI_SUMMARY_API_CLIENT_URL,
        ],
      });

      datadogRum.startSessionReplayRecording();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
